export var ButtonVariant;
(function (ButtonVariant) {
    ButtonVariant["CHAMFERED"] = "chamfered";
    ButtonVariant["PRIMARY_FILLED"] = "primaryFilled";
    ButtonVariant["SECONDARY_FILLED"] = "secondaryFilled";
    ButtonVariant["PRIMARY_OUTLINED"] = "primaryOutlined";
    ButtonVariant["SECONDARY_OUTLINED"] = "secondaryOutlined";
    ButtonVariant["PRIMARY_OUTLINED_WHITE"] = "primaryOutlinedWhite";
    ButtonVariant["SECONDARY_OUTLINED_WHITE"] = "secondaryOutlinedWhite";
    ButtonVariant["PRIMARY_TEXT_ONLY"] = "primaryTextOnly";
    ButtonVariant["SECONDARY_TEXT_ONLY"] = "secondaryTextOnly";
    ButtonVariant["ICON"] = "icon";
})(ButtonVariant || (ButtonVariant = {}));
//# sourceMappingURL=Button.types.js.map